
export type TabSettings = {
  id?: number;
  username: string;
  tab: string;
  cols: string;
  updated: Date | null;
};


export function mapJsonToTabSettings(jsonData: any): TabSettings {
  return {
    id: jsonData.BT75_ID || 0,
    username: jsonData.BT75_USERNAME || '',
    tab: jsonData.BT75_TAB || '',
    cols: jsonData.BT75_COLS || '',
    updated: jsonData.BT75_UPDATED ? new Date(jsonData.BT75_UPDATED) : null,
  };
}

export function mapTabSettingsToJson(tabCols: TabSettings) {
  return {
    BT75_ID: tabCols.id,
    BT75_USERNAME: tabCols.username,
    BT75_TAB: tabCols.tab,
    BT75_COLS: tabCols.cols,
    BT75_UPDATED: tabCols.updated ? tabCols.updated.toISOString() : null,
  };
}


export type EmailForm = {
  email: string;
  subject: string;
  message: string;
  attachment: string;
  tipo: string;
};


export type EmailSubmitForm = {
                emailTo?      :string;
  };



export type ReportDateForm = {
                fromDate?     :Date;
                toDate?      :Date;
                emailTo?      :string;
  };


export type DropProgetti = {
  idprog?: string;
  codprog?: string;
  desprog?: string;
  desprogblocco?: string;
  ditta?: number;
  indclibloc?: number;
  ref?: string
};

export type DropProgettiApiResponse = {
  results: Array<DropProgetti>;
  count: number;
};

export type DropNodi = {
  idnodo?: string;
  codprog?: string;
  codnodo?: string;
  ditta?: number;
  desnodo?: string;
  tiponodo?: string;
};

export type DropNodiApiResponse = {
  results: Array<DropNodi>;
  count: number;
};

export type DropAttivita = {
  idatt?: string;
  codprog?: string;
  codatt?: string;
  ditta?: number;
  desatt?: string;
};

export type DropAttivitaApiResponse = {
  results: Array<DropAttivita>;
  count: number;
};
